import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import Style from './Style.module.css'
import Header from '../../../Components/AdminComponents/Header/Header'
import Sidebar from '../../../Components/AdminComponents/Sidebar/Sidebar'
import DataTable from '../../../Components/AdminComponents/DataTable/DataTable'
import adminInstance from '../../../instance/AdminInstance';
import Widgets from '../../../Components/AdminComponents/Widgets/Widgets';

const ProductsList = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const columns = [
    {
      name: 'ID',
      selector: (row) => row._id,
      sortable: true,
    },
    {
      name: 'Title',
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: 'Price',
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: 'Options',
      cell: (row) => (
        <div className={Style.optionsContainer}>
          <button className={Style.viewButton} onClick={() => navigate(`/admin/products/singles/${row._id}`)}>View</button>
          <button className={Style.deleteButton} onClick={() => handleDelete(row._id)}>Block</button>
        </div>
      ),
      width: '160px'
    },
  ];



   const loadProducts = () => {

    try {
      adminInstance.get("/api/super_admin/add_control/get_adds").then((response) => {
        setProducts([...response.data]);
      }).catch((error) => {
        console.log(error);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);


  const handleDelete = (itemId) => {
    adminInstance
      .delete(`/api/super_admin/product_control/delete_product/${itemId}`)
      .then(() => loadProducts())
      .catch((err) => console.error(err));
  };

  return (
    <div className={Style.list}>
      <Sidebar />
      <div className={Style.listContainer}>
        <Header />
        <div className={Style.widgets}>
          <Widgets type="ads" number={products.length} />
          <Widgets type="revenue" revenueValue={products.reduce((acc, ad) => acc + (ad.price || 0), 0)} />
        </div>
        <DataTable Row={products} Columns={columns} ActionColumn="" Title="Advertisements" Path="Advertisements" />
      </div>
    </div>
   
  );
};

export default ProductsList;
